/** Stable storage identifiers shared by web, iOS, Android, and race callables. */
export const VENUE_AMENITY_IDS = [
  "swimming_pool",
  "gym",
  "hot_tub",
  "showers",
  "accommodation",
  "buffet",
  "restaurant",
  "bike_wash",
  "live_music",
  "massage",
  "sauna",
] as const;

export type VenueAmenity = (typeof VENUE_AMENITY_IDS)[number];

/** Read tolerantly so older clients can display a future catalog safely. */
export const normalizeVenueAmenities = (value: unknown): VenueAmenity[] => {
  if (!Array.isArray(value)) return [];
  const selected = new Set(value);
  return VENUE_AMENITY_IDS.filter((id) => selected.has(id));
};
